import { createApiClient } from '@hr/api';
import { createApiQueryHook } from '@hr/api/swr';
import { createAxiosTransport } from '@hr/api/axios';

import { getAxiosInstance } from 'src/lib/axios';

export * from '@hr/api';

export { matchApiQuery } from '@hr/api/swr';

// ----------------------------------------------------------------------

const transport = createAxiosTransport(getAxiosInstance);

export const api = createApiClient(transport);

export const useApiQuery = createApiQueryHook(transport);
